// extracted by mini-css-extract-plugin
export default {"dialog":"SubscriptionRequiredDialog_dialog__0Ue2v","formButton":"SubscriptionRequiredDialog_formButton__xtshJ"};